import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=32c6b2bb&scoped=true"
import script from "./ListTable.vue?vue&type=script&lang=js"
export * from "./ListTable.vue?vue&type=script&lang=js"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=32c6b2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6b2bb",
  null
  
)

export default component.exports